

export default {
  props: {
    active: {
      type: Boolean,
      default: false
    }
  }
};
